import * as React from 'react';
import { Component } from 'react';
import * as navigate from 'app/area/shared/navigation';
import { ButtonTertiary } from 'ui';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import { TopPanel } from 'app/area/administration/edit/components';
import { createFormatters } from 'app/infrastructure/data/date';
import { AdministrationRoleEditProps } from 'app/area/administration/edit/role/types';
import { RoleEditMenu } from 'app/area/administration/edit/role/role-edit-menu';
import { DefaultRoleButton } from 'app/area/administration/edit/role/default-role-button';
import { Tag } from 'app/components/tag';
import { replaceTemplateString } from 'app/infrastructure/platform';
import styles from './role.scss';

export class RoleStickyHeader extends Component<AdministrationRoleEditProps> {
  private formatters: any;

  public constructor(props: AdministrationRoleEditProps) {
    super(props);
    this.formatters = createFormatters(props.sharedState.locale);
  }

  private onCancel = () => {
    navigate.toAdminRoleList(false);
  };

  public render() {
    const {
      optionsFetching, data, accessPerson, translation, showEditMenu, hideTopPanel, markedAsDefaultRole
    } = this.props;


    return <StickyHeader className={`headerpanel ${styles.headerWrapper} ${styles.headerSticky} header-panel`}
      rightSideContent={
        <><StickyHeaderButtonContainer>
          <ButtonTertiary onClick={this.onCancel}>{translation.cancel}</ButtonTertiary>
          <DefaultRoleButton {...this.props} />
        </StickyHeaderButtonContainer>
          {showEditMenu && <RoleEditMenu
            id={data.id}
            optionsFetching={optionsFetching}
            accessPerson={accessPerson}
            labelDelete={translation.delete_item}
            labelCancel={translation.cancel}
            labelDescription={replaceTemplateString(
              translation.delete_role_desc, data.name)}
            labelDuplicate={translation.edit_role_duplicate_role}
            onDelete={this.props.deleteRole}
          />}</>
      }>
      <div className={styles.content}>
        <div className={styles.info}>
          {this.props.showRoleId ? <span className={styles.id}>
            #{this.props.id}
          </span> : null}
          {this.props.title &&
            <span className={styles.title} aria-hidden={true}>
              {this.props.title}
            </span>}
        </div>
        <div className={styles.rightSide}>
          {markedAsDefaultRole && <Tag className={styles.tag}>{translation.default}</Tag>}
        </div>
      </div>
      {!hideTopPanel && <TopPanel
        data={data}
        translation={translation}
        formatters={this.formatters} />}
    </StickyHeader>;
  }
}
